"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./registration.request"), exports);
__exportStar(require("./demographics.request"), exports);
__exportStar(require("./coverage.request"), exports);
__exportStar(require("./consent.request"), exports);
__exportStar(require("./merge.request"), exports);
__exportStar(require("./search.request"), exports);
__exportStar(require("./protection.request"), exports);
__exportStar(require("./identity-resolution.request"), exports);
__exportStar(require("./identity-match-config.request"), exports);
// ---------------------------------------------------------------------------
// Appointment bounded context (Stage 5B.5)
// ---------------------------------------------------------------------------
__exportStar(require("./appointment-common.request"), exports);
__exportStar(require("./appointment-search.request"), exports);
__exportStar(require("./booking.request"), exports);
__exportStar(require("./scheduling.request"), exports);
__exportStar(require("./check-in.request"), exports);
__exportStar(require("./queue.request"), exports);
__exportStar(require("./waitlist.request"), exports);
__exportStar(require("./slot-management.request"), exports);
__exportStar(require("./doctor-availability.request"), exports);
__exportStar(require("./reminder.request"), exports);
// ---------------------------------------------------------------------------
// Financial bounded context (Stage 5C.4)
// ---------------------------------------------------------------------------
__exportStar(require("./financial-common.request"), exports);
__exportStar(require("./financial-payment.request"), exports);
__exportStar(require("./financial-receipt.request"), exports);
__exportStar(require("./financial-advance-deposit.request"), exports);
__exportStar(require("./financial-refund.request"), exports);
__exportStar(require("./financial-refund-request.request"), exports);
__exportStar(require("./financial-payment-correction.request"), exports);
__exportStar(require("./financial-receipt-correction.request"), exports);
__exportStar(require("./financial-correction-workflow.request"), exports);
__exportStar(require("./financial-patient-correction.request"), exports);
__exportStar(require("./financial-ip-drug-cancel.request"), exports);
__exportStar(require("./financial-correction-register.request"), exports);
__exportStar(require("./financial-correction-report.request"), exports);
__exportStar(require("./financial-tariff.request"), exports);
__exportStar(require("./financial-package.request"), exports);
__exportStar(require("./financial-discount.request"), exports);
__exportStar(require("./financial-posting.request"), exports);
__exportStar(require("./financial-approval.request"), exports);
__exportStar(require("./financial-billing.request"), exports);
__exportStar(require("./op-billing.request"), exports);
__exportStar(require("./op-billing-register.request"), exports);
__exportStar(require("./financial-journal.request"), exports);
__exportStar(require("./financial-general-ledger.request"), exports);
__exportStar(require("./financial-receivable.request"), exports);
__exportStar(require("./financial-adjustment.request"), exports);
__exportStar(require("./financial-payable.request"), exports);
__exportStar(require("./financial-cash-bank.request"), exports);
// ---------------------------------------------------------------------------
// Clinical bounded context (Stage 6C.4)
// ---------------------------------------------------------------------------
__exportStar(require("./clinical-common.request"), exports);
__exportStar(require("./clinical-encounter.request"), exports);
__exportStar(require("./clinical-document.request"), exports);
__exportStar(require("./clinical-order.request"), exports);
__exportStar(require("./clinical-timeline.request"), exports);
__exportStar(require("./clinical-approval.request"), exports);
__exportStar(require("./draft-registration.request"), exports);
// ---------------------------------------------------------------------------
// Laboratory masters admin (create / edit / switch on and off)
// ---------------------------------------------------------------------------
__exportStar(require("./lab-masters-admin.request"), exports);
__exportStar(require("./financial-appointment-correction.request"), exports);
//# sourceMappingURL=index.js.map